
export const Roadmap = () => {
  return (
    <div id="roadmap">
      <div className="row">
        <div className="col-xs-12 col-md-6">
          <div className="about-text">
            <h2>ROADMAP</h2>        
            <h4>The roadmap will be focused on The Greyhound App since it's the core feature of the whole project. Inside the application we will be able to create content that can be rewarded with ADA or NFTs. We can also will be able to create tournaments, weekly challenges to earn rewards and more!</h4>    
          </div>
        </div>
        <div className="col-xs-12 col-md-6" style={{display: 'flex', justifyContent: 'center'}}>
          <img src={'./img/roadmap.png'} className="img-responsive" alt="" />{" "}
        </div>
      </div>
    </div>
  )
}
